import { selectedEnv } from './constant';

export const checkIsApplicable = (options) => !(options?.length === 1 && options?.[0]?.value?.toLowerCase() === 'not applicable');
export const isEksnsConfigured = ({ order }) => {
    let configured = false;
    const eksnsOrderComponent = {
        ...order?.resourceMgmt?.[selectedEnv]?.components?.filter(
            (component) => component?.componentId === 'RI003-EKSNS' && component?.groupType === 'mandatoryComponents'
        )?.[0],
    };

    if (eksnsOrderComponent?.configureData && Object?.keys(eksnsOrderComponent?.configureData)?.length > 0) {
        configured = true;
    }
    return configured;
};
export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const resetOrder = {
    catalogCode: null,
    projectId: null,
    projectDetails: null,
    businessUnit: null,
    sector: null,
    program: null,
    appUrl: null,
    appContextPath: null,
    division: null,
    budgetCode: null,
    budgetCodeDetails: null,
    billingInfo: null,
    environment: null,
    dataClassification: null,
    environmentDetails: null,
    businessAppService: 'No',
    businessApp: null,
    appService: null,
    appOwner: null,
    appOwnerDetails: null,
    certificateOwnerOne: null,
    certificateOwnerOneDetails: null,
    certificateOwnerTwo: null,
    certificateOwnerTwoDetails: null,
    applicationName: null,
    appShortName: null,
    businessContact: null,
    businessContactDetails: null,
    privilegedADGroup: null,
    nonPrivilegedADGroup: null,
    nonPrivilegedADGroupList: [{ readerValue: '' }],
    privilegedADGroupList: [{ contributorValue: '' }],
    privilegedADGroupOwner: null,
    privilegedADGroupOwnerDetails: null,
    nonPrivilegedADGroupOwner: null,
    nonPrivilegedADGroupOwnerDetails: null,
    appSupportMailId: null,
    isaNumber: null,
    iteAppService: null,
    isExternal: 'No',
    isTouched: false,
};
export const isUniqueOwner = (value = null, selectedvalues = []) => {
    return selectedvalues.indexOf(value) === -1;
};

// Maps raw API engine codes to the database edition values used by the SQL/POSTGRESQL/MYSQL/ORACLE forms.
const ENGINE_EDITION_MAP = {
    'sqlserver-ee': 'enterprise',
    mysql: 'community',
    postgres: 'standard',
    'oracle-ee': 'enterprise',
};

// Reverse of ENGINE_EDITION_MAP, scoped per component type since edition labels (e.g. 'standard') aren't unique across engines.
const EDITION_ENGINE_MAP = {
    SQL: { enterprise: 'sqlserver-ee' },
    POSTGRESQL: { standard: 'postgres' },
    MYSQL: { community: 'mysql' },
    ORACLE: { enterprise: 'oracle-ee' },
};

export function transformModifiedComponent(components, componentGroups) {
    const modifiedComponents = componentGroups.flatMap((group) => {
        return group.components.map((component) => {
            const getComponentById = components.find((apiComponent) => apiComponent['component-id'] === component.componentId);
            const configureData =
                getComponentById && Object.keys(getComponentById).length > 1
                    ? Object.fromEntries(Object.entries(getComponentById).filter(([key]) => key !== 'component-id'))
                    : null;
            return configureData ? { ...component, configureData } : { ...component };
        });
    });
    return modifiedComponents;
}

const getSelectedComponentsForEdit = (data, componentGroups, orderComponents, catalogConfig) => {
    const componentMap = new Map();
    // Create a map of orderComponents for quick lookup
    orderComponents.forEach((orderComponent) => {
        const componentId = orderComponent['component-id'];
        componentMap.set(componentId, { ...orderComponent });
    });

    const selectedComponents = [];
    // Iterate through each group in componentGroups
    componentGroups.forEach((group) => {
        group.components.forEach((component) => {
            const { componentId } = component;
            const orderComponent = componentMap.get(componentId);
            if (orderComponent) {
                // Initialize the component object to be added to the local state
                const localComponent = { ...component };

                // Assign configureData based on configurationComponentCode
                if (localComponent.configurable && orderComponent) {
                    switch (localComponent.configurationComponentCode) {
                        case 'AWSACC': {
                            const businessApp = orderComponent['business-application'] || catalogConfig?.businessApplication || null;
                            localComponent.configureData = {
                                awsCloudOnboardingOrderId: orderComponent.awsAccountOnboardOrderId || orderComponent['aws-cloud-onboarding-order-id'],
                                businessApplication: businessApp,
                                businessApplicationDetails: businessApp ? { businessApplicationName: businessApp } : null,
                                applicationService:
                                    orderComponent.applicationService || orderComponent['application-service'] || catalogConfig?.applicationService || null,
                                department: orderComponent['aws-department'] || catalogConfig?.department || null,
                                businessCategory: orderComponent.businessCategory || orderComponent['business-category'],
                                vpcName: orderComponent.vpcName || orderComponent['vpc-name'],
                                vpcId: orderComponent.vpcId || orderComponent['vpc-id'],
                                awsAccountName: orderComponent['aws-account-name'],
                                awsOrganizationalUnit: orderComponent['aws-organizational-unit'],
                            };
                            break;
                        }
                        case 'EKSNS':
                            localComponent.configureData = {
                                program: orderComponent?.program === 'Global Shared' ? 'Not Applicable' : orderComponent?.program,
                                eksDepartment: orderComponent?.department || orderComponent?.eksDepartment,
                                eksAdGroup: orderComponent?.adGroup || orderComponent?.cluster,
                            };
                            break;
                        case 'SQL':
                            localComponent.configureData = {
                                sqlDatabaseEdition:
                                    ENGINE_EDITION_MAP[orderComponent.engine] || orderComponent.engine || orderComponent['sql-database-edition'],
                                sqlDatabaseVersion: orderComponent.dbVersion || orderComponent['sql-database-version'],
                                databaseName: orderComponent.dbName || orderComponent['database-name'],
                                domain: orderComponent.domain,
                                sqlAccountName: orderComponent.sqlAccountName || orderComponent['sql-account-name'],
                            };
                            break;
                        case 'POSTGRESQL':
                            localComponent.configureData = {
                                postgreSqlDatabaseEdition:
                                    ENGINE_EDITION_MAP[orderComponent.engine] || orderComponent.engine || orderComponent['postgresql-database-edition'],
                                postgreSqlDatabaseVersion: orderComponent.dbVersion || orderComponent['postgresql-database-version'],
                                databaseName: orderComponent.dbName || orderComponent['database-name'],
                            };
                            break;
                        case 'MYSQL':
                            localComponent.configureData = {
                                mySqlDatabaseEdition: ENGINE_EDITION_MAP[orderComponent.engine] || orderComponent.engine,
                                mySqlDatabaseVersion: orderComponent.dbVersion || orderComponent['mysql-database-version'],
                                databaseName: orderComponent.dbName,
                            };
                            break;
                        case 'ORACLE':
                            localComponent.configureData = {
                                oracleDatabaseEdition: ENGINE_EDITION_MAP[orderComponent.engine] || orderComponent.engine,
                                oracleDatabaseVersion: orderComponent.dbVersion || orderComponent['oracle-database-version'],
                                databaseName: orderComponent.dbName,
                            };
                            break;
                        case 'SNS': {
                            const subscriptionsData = orderComponent.subscriptions || {};
                            localComponent.configureData = {
                                subscriptions: Object.entries(subscriptionsData).map(([key, val]) => ({
                                    protocol: key.charAt(0).toUpperCase() + key.slice(1),
                                    protocolValue: key,
                                    endpointValue: val.endpoint || '',
                                    selected: true,
                                })),
                            };
                            break;
                        }
                        case 'REDIS':
                            localComponent.configureData = {
                                redisType: orderComponent.redisType || orderComponent['redis-type'],
                            };
                            break;
                        default:
                            break;
                    }
                }

                // Add the configured component to the selectedComponents array
                selectedComponents.push(localComponent);
            }
        });
    });

    return selectedComponents;
};
export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null, componentGroups) => {
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const envConfiguration = catalogConfig?.environmentConfigurations?.[0];
    const privilegedADGroup = envConfiguration?.contributorAdGroups?.length ? 'Yes' : 'No';
    const nonPrivilegedADGroup = envConfiguration?.readerAdGroups?.length ? 'Yes' : 'No';
    const mycertADGroup = catalogConfig?.activeDirectoryCertificateGroup ? 'Yes' : 'No';
    const resourceMgmtComponents = { components: getSelectedComponentsForEdit(data, componentGroups, envConfiguration?.components, catalogConfig) };
    return {
        catalogCode: catalog?.catalogServiceCode,
        // projectId: catalogConfig?.projectId ? catalogConfig?.projectId : null,
        // projectDetails: catalogConfig?.projectId
        //     ? {
        //           businessUnit: catalogConfig?.businessUnit,
        //           hyperionNumber: catalogConfig?.budgetCode,
        //           impactedSectors: catalogConfig?.sector,
        //           projectNumber: catalogConfig?.projectId,
        //       }
        //     : null,
        // businessUnit: catalogConfig?.businessUnit,
        isExternal: catalogConfig?.isExternal ? 'Yes' : 'No',
        appProfile: catalogConfig?.applicationService,
        sector: catalogConfig?.sector,
        // program: catalogConfig?.program === 'Global Shared' ? 'Not Applicable' : catalogConfig?.program,
        appUrl: envConfiguration?.applicationUrl,
        department: catalogConfig?.department || null,
        appContextPath: catalogConfig?.applicationContextPath,
        appRegion: catalogConfig?.applicationRegion || null,
        budgetCode: catalogConfig?.costCenter,
        // billingInfo: catalogConfig?.billingInformation,
        ...(catalogConfig?.region && {
            landingZoneDetails: {
                region: catalogConfig?.region,
                regionDisplayName: catalogConfig?.region,
            },
        }),
        environment: envConfiguration?.environmentDisplayName,
        dataClassification: catalogConfig?.dataClassification,
        // businessAppService: catalogConfig?.businessApplication && catalogConfig?.applicationService ? 'Yes' : 'No',
        // businessApp: catalogConfig?.businessApplication ? catalogConfig?.businessApplication : catalogConfig?.applicationName,
        // businessApp: catalogConfig?.businessApplication,
        appService: !catalogConfig?.applicationService
            ? `${catalogConfig?.applicationName} ${['production']?.includes(catalogConfig?.environment?.toLowerCase()) ? 'PROD' : 'NON-PROD'}`
            : catalogConfig?.applicationService,
        applicationName: catalogConfig?.applicationName,
        appShortName: catalogConfig?.applicationShortName,
        // appOwner: data?.manager?.id,
        appOwner: null,
        appOwnerDetails: { name: data?.manager?.name, gpid: data?.manager?.id },
        businessContact: null,
        businessContactDetails: { gpid: catalogConfig?.businessOwnerId },
        // ...(['production']?.includes(catalogConfig?.environment?.toLowerCase()) && {
        //     isaNumber: catalogConfig?.isaNumber,
        //     iteAppService: catalogConfig?.iteApplicationName,
        // }),
        myCertADGroup: mycertADGroup,
        privilegedADGroup,
        nonPrivilegedADGroup,
        ...(privilegedADGroup === 'Yes' && {
            privilegedADGroupList: envConfiguration?.contributorAdGroups.map((app) => ({
                contributorValue: app,
                contributorInputValue: app,
            })),
        }),
        ...(nonPrivilegedADGroup === 'Yes' && {
            nonPrivilegedADGroupList: envConfiguration?.readerAdGroups.map((app) => ({
                readerValue: app,
                readerInputValue: app,
            })),
        }),
        ...(!['production']?.includes(envConfiguration?.environmentDisplayName?.toLowerCase()) &&
            nonPrivilegedADGroup === 'No' && {
                nonPrivilegedADGroupOwner: `${data?.activeDirectoryGroupOwner?.id} - ${data?.activeDirectoryGroupOwner?.name}`,
                nonPrivilegedADGroupOwnerDetails: data?.activeDirectoryGroupOwner,
            }),
        ...(!['production']?.includes(envConfiguration?.environmentDisplayName?.toLowerCase()) &&
            privilegedADGroup === 'No' && {
                privilegedADGroupOwner: `${data?.activeDirectoryGroupOwner?.id} - ${data?.activeDirectoryGroupOwner?.name}`,
                privilegedADGroupOwnerDetails: data?.activeDirectoryGroupOwner,
            }),
        ...(['production']?.includes(envConfiguration?.environmentDisplayName?.toLowerCase()) &&
            privilegedADGroup === 'No' && {
                privilegedADGroupOwner: `${data?.activeDirectoryGroupOwner?.id} - ${data?.activeDirectoryGroupOwner?.name}`,
                privilegedADGroupOwnerDetails: data?.activeDirectoryGroupOwner,
            }),
        createdBy: data?.created?.by,
        appSupportMailId: catalogConfig?.appSupportMailId,
        ...(mycertADGroup === 'Yes' && {
            adCertGroup: catalogConfig?.activeDirectoryCertificateGroup,
        }),
        ...(mycertADGroup === 'No' && {
            myCertADGroupOwner: `${data?.activeDirectoryGroupOwner?.id} - ${data?.activeDirectoryGroupOwner?.name}`,
            myCertADGroupOwnerDetails: data?.activeDirectoryGroupOwner,
        }),
        resourceMgmt: {
            [selectedEnv]: resourceMgmtComponents,
        },
        isTouched: false,
    };
};

export const formOrderObjFromLaunchpad = (data = null) => {
    return {
        sector: data?.sector,
        environment: data?.environment,
        appProfile: data?.applicationService,
        applicationName: data?.applicationName,
        appShortName: data?.applicationShortName,
        appOwner: null,
        appOwnerDetails: { name: data?.applicationOwner?.name, gpid: data?.applicationOwner?.gpid },
        businessContact: null,
        businessContactDetails: { name: data?.applicationOwner?.name, gpid: data?.applicationOwner?.gpid },
        isExternal: data?.riDevelopmentType === 'WebApplication' ? 'Yes' : 'No',
        budgetCode: data?.budgetCode,
        appSupportMailId: data?.appSupportDL,
        privilegedADGroup: 'Yes',
        privilegedADGroupList: [{ contributorValue: data?.privilegedADGroup, contributorInputValue: data?.privilegedADGroup }],
        nonPrivilegedADGroup: 'Yes',
        nonPrivilegedADGroupList: [{ readerValue: data?.nonprivilegedADGroup, readerInputValue: data?.nonprivilegedADGroup }],
        isTouched: false,
    };
};

export const getComponentsFromSchema = ({ componentGroups = [], exceptPrompt = [], particularPrompt = [] }) => {
    // If particularPrompt is specified, filter groups by their groupType
    if (particularPrompt.length > 0) {
        const filteredGroups = componentGroups?.filter((group) => particularPrompt.includes(group.groupType));
        return filteredGroups?.map((group) => ({
            ...group,
            components: group.components.filter((component) => particularPrompt.includes(component.componentId) || particularPrompt.includes(group.groupType)),
        }));
    }

    // Filter groups to exclude specified groupTypes
    const filteredGroups = componentGroups?.filter((group) => !exceptPrompt.includes(group.groupType));

    // Return the filtered groups with their components
    return filteredGroups?.map((group) => ({
        ...group,
        components: group.components.filter((component) => !exceptPrompt.includes(component.componentId)),
    }));
};
export const generateConfigPayload = (components) => {
    return components.map((component) => {
        const result = {
            'component-id': component?.componentId,
        };
        // Add specific configuration data based on the component
        if (component?.configurable && component?.configureData) {
            if (component?.configurationComponentCode === 'EKSNS') {
                result.department = component?.configureData?.eksDepartment;
                result.program = component?.configureData?.program;
                result.adGroup = component?.configureData?.eksAdGroup;
            } else if (component?.configurationComponentCode === 'SQL') {
                result.engine = EDITION_ENGINE_MAP.SQL[component?.configureData?.sqlDatabaseEdition] || component?.configureData?.sqlDatabaseEdition;
                result.dbVersion = component?.configureData?.sqlDatabaseVersion;
                result.dbName = component?.configureData?.databaseName;
                result.domain = component?.configureData?.domain;
                result.sqlAccountName = component?.configureData?.sqlAccountName;
            } else if (component?.configurationComponentCode === 'POSTGRESQL') {
                result.engine =
                    EDITION_ENGINE_MAP.POSTGRESQL[component?.configureData?.postgreSqlDatabaseEdition] || component?.configureData?.postgreSqlDatabaseEdition;
                result.dbVersion = component?.configureData?.postgreSqlDatabaseVersion;
                result.dbName = component?.configureData?.databaseName;
            } else if (component?.configurationComponentCode === 'MYSQL') {
                result.engine = EDITION_ENGINE_MAP.MYSQL[component?.configureData?.mySqlDatabaseEdition] || component?.configureData?.mySqlDatabaseEdition;
                result.dbVersion = component?.configureData?.mySqlDatabaseVersion;
                result.dbName = component?.configureData?.databaseName;
            } else if (component?.configurationComponentCode === 'ORACLE') {
                result.engine = EDITION_ENGINE_MAP.ORACLE[component?.configureData?.oracleDatabaseEdition] || component?.configureData?.oracleDatabaseEdition;
                result.dbVersion = component?.configureData?.oracleDatabaseVersion;
                result.dbName = component?.configureData?.databaseName;
            } else if (component?.configurationComponentCode === 'AWSACC') {
                result.awsAccountOnboardOrderId = component?.configureData?.awsCloudOnboardingOrderId;
                result.businessCategory = component?.configureData?.businessCategory;
                result.vpcId = component?.configureData?.vpcId;
                result.vpcName = component?.configureData?.vpcName;
            } else if (component?.configurationComponentCode === 'SNS') {
                const subsObj = {};
                (component?.configureData?.subscriptions || []).forEach((sub) => {
                    if (sub.selected && sub.endpointValue?.trim()) {
                        subsObj[sub.protocolValue] = {
                            protocol: sub.protocolValue,
                            endpoint: sub.endpointValue.trim(),
                        };
                    }
                });
                result.subscriptions = subsObj;
            } else if (component?.configurationComponentCode === 'REDIS') {
                result.redisType = component?.configureData?.redisType;
            }
        }

        return result;
    });
};

const getUniqueComponentIdsFromFlatArray = (components = []) => {
    return Array.from(new Set(components?.map((component) => component?.componentId)));
};

const getUniqueComponentIdsFromGroups = (componentGroups) => {
    const allComponentIds = componentGroups?.flatMap((group) => group?.components.map((component) => component.componentId));
    return Array.from(new Set(allComponentIds));
};

// Comparison function
export const compareComponentIdsLength = (components, componentGroups) => {
    const uniqueIdsFromFlatArray = getUniqueComponentIdsFromFlatArray(components);
    const uniqueIdsFromGroups = getUniqueComponentIdsFromGroups(componentGroups);

    const lengthFromFlatArray = uniqueIdsFromFlatArray.length;
    const lengthFromGroups = uniqueIdsFromGroups.length;

    return {
        lengthFromFlatArray,
        lengthFromGroups,
        areEqual: lengthFromFlatArray === lengthFromGroups,
    };
};

/**
 * Extracts AWSACC configureData fields from a completed AWS Cloud Onboarding order API response.
 * Used to pre-populate the AWS Account configuration modal when a valid order ID is entered.
 */
export const formAwsAccConfigFromOrderDetails = (data = null) => {
    if (!data) return {};
    const catalog = data?.catalogServices?.[0] || null;
    const catalogConfig = catalog?.catalogConfig || null;

    return {
        businessApplication: catalogConfig?.businessApplication || null,
        businessCategory: catalogConfig?.businessCategory || null,
        applicationService: catalogConfig?.applicationService || null,
    };
};
